var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[(_vm.hasNewNotifications)?_c('b-alert',{attrs:{"type":"error","message":_vm.notificationMemo,"has-content":false,"has-header-button":true,"button-title":_vm.buttonTitle,"dismissible":false},on:{"emitAction":function($event){return _vm.$root.goTo(_vm.buttonLink)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }